export const stromaAnswerCard = {
  border: '1px solid var(--line)',
  borderRadius: '16px',
  bgcolor: 'var(--surface)',
  backgroundImage: 'linear-gradient(180deg, var(--surface), var(--surface2))',
  boxShadow: 'inset 0 1px 0 var(--hi), var(--shadow)',
  overflow: 'hidden',
} as const;

export const stromaCompactPanel = {
  border: '1px solid var(--line)',
  borderRadius: '12px',
  bgcolor: 'var(--surface)',
  boxShadow: 'inset 0 1px 0 var(--hi)',
} as const;

export const stromaWalkCard = {
  border: '1px solid var(--line)',
  borderRadius: '14px',
  bgcolor: 'var(--surface)',
  boxShadow: 'inset 0 1px 0 var(--hi)',
  p: 2,
} as const;

export const stromaInset = {
  border: '1px solid var(--line-soft)',
  borderRadius: '10px',
  bgcolor: 'var(--sunk)',
} as const;

export const stromaSectionLabel = {
  color: 'var(--ink-3)',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
} as const;

export const stromaFocusRing = {
  outline: 'none',
  '&:focus-visible': {
    outline: '2px solid var(--accent)',
    outlineOffset: '2px',
    boxShadow: '0 0 0 3px var(--accent-soft)',
  },
} as const;
